import Page from 'components/pages/sitemaps'
import requestInit from 'request/sitemaps/init'

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  const [version, type, page] = params.params
  if (version !== 'v1') throw Error('wrong version')
  const types = ['tag', 'regionTag', 'stylist', 'regionStylist', 'regionStylistEvent', 'regionStudioEvent']
  if (!types.includes(type)) throw Error('wrong type')
  const initData = await requestInit({ type, page: parseInt(page) || 0 })
  initData.type = type
  return { props: initData, revalidate: 60 * 60 }
}

export default function Sitemaps(initData) {
  const t = useI18n()
  const { type } = initData
  const title = t.seo.title('sitemaps', { name: t(`page:sitemaps.tabs.${type}`) })
  return (
    <>
      <C.Head>
        { h.seo({ title }) }
      </C.Head>
      <Page initData={ initData }/>
    </>
  )
}
